import React from 'react'
import {  useNavigate } from 'react-router-dom'
import { FaDotCircle } from "react-icons/fa";
import { FaRegCircleDot } from "react-icons/fa6";

const HomePage = () => {
   const navigate = useNavigate();
  return (
   <div>
     <div className='flex justify-center h-screen items-center select-none'>
        <div className=' space-y-2 text-lg font-semibold border-4 border-theme-5  px-4 py-4 flex flex-col items-center'>
        <div className='flex text-2xl justify-center items-center mb-2 text-theme-2 '>
          <h4 className='font-roboto-slab font-bold mr-1'>Dot Connect</h4>
          <a href='https://shijazks.vercel.app'><FaRegCircleDot className='pt-[2px]'/></a>
        </div>
        <div className=' py-1 w-[200px] text-theme-3 text-center hover:bg-theme-2 bg-theme-5' onClick={()=>{navigate('/twoplayer')}}>2 Player</div>
        <div className=' py-1 w-[200px] text-theme-3 text-center hover:bg-theme-2 bg-theme-5' onClick={()=>{navigate('/multiplayer')}}>Multiplayer</div>
        <div className=' py-1 w-[200px] text-theme-3 text-center hover:bg-theme-2 bg-theme-5' onClick={()=>{navigate('/computer')}}>Computer</div>
        <div className=' py-1 w-[200px] text-theme-3 text-center hover:bg-theme-2 bg-theme-5' onClick={()=>{navigate('/online')}}>Online</div>
        <div className=' py-1 w-[200px] text-theme-3 text-center hover:bg-theme-2 bg-theme-5' onClick={()=>{navigate('/howtoplay')}}>How To Play</div>
        </div>
    </div>
   </div>
  )
}

export default HomePage